export const CircularProgressStyle = {
  CircularProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
};
